export default {"src":"/_next/static/media/email_verified.d9661b02.svg","height":436,"width":463,"blurWidth":0,"blurHeight":0};